export class Size {
    public static readonly Small: 'small' | 'medium-small' | 'medium' | 'large' = 'small';
    public static readonly MediumSmall: 'small' | 'medium-small' | 'medium' | 'large' =
        'medium-small';
    public static readonly Medium: 'small' | 'medium-small' | 'medium' | 'large' = 'medium';
    public static readonly Large: 'small' | 'medium-small' | 'medium' | 'large' = 'large';
}
